import { getInitConfig } from 'ziphy-web-shared';
import { PRIMARY_COLORS_BY_BRAND, PRIMARY_HOVER_COLORS_BY_BRAND } from 'ziphy-web-shared/basic/constants/colors';
export const useSelectedBrand = () => {
    const initConfig = getInitConfig();
    const selectedBrand = initConfig.selectedBrand || 'kerna';
    const primaryColor = PRIMARY_COLORS_BY_BRAND[selectedBrand];
    const primaryHoverColor = PRIMARY_HOVER_COLORS_BY_BRAND[selectedBrand];
    return {
        selectedBrand: initConfig.selectedBrand || 'kerna',
        isZiphy: initConfig.selectedBrand === 'ziphy',
        primaryColor,
        primaryHoverColor,
    };
};
